/**
 * Store for Hubspot Conversation widget
 */
import { createEffect, createEvent, createStore, sample } from 'effector';

const initialHubspotConversationState = {
  visible: false,
};

export const $hubspotConversation = createStore(initialHubspotConversationState);
export const showHubspotConversationEvent = createEvent();

const showHubspotConversationEffect = createEffect(() => {
  return new Promise((resolve) => {
    window.HubSpotConversations.widget.load();
    window.HubSpotConversations.widget.open();
    window.HubSpotConversations.on('widgetClosed', () => {
      window.HubSpotConversations.widget.remove();
      resolve(null);
    });
  });
});

$hubspotConversation.on(showHubspotConversationEvent, (state) => {
  return { ...state, visible: true };
});

// when effect is done then chat wiget is closed
$hubspotConversation.on(showHubspotConversationEffect.done, (state) => {
  return { ...state, visible: false };
});

sample({
  source: $hubspotConversation,
  clock: showHubspotConversationEvent,
  target: showHubspotConversationEffect,
});
